module.exports = __webpack_public_path__ + "static/img/logo-light-new.cbb35f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/logo-light-new.png
// module id = aAAl
// module chunks = 0